
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    DAILY_DEVICE_AUDIT_REQUEST,
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import { clientQuery } from 'Core/data/GraphQLApi';
import { dailyDeviceAuditResult } from 'Redux/actions';


function* updateChange({ payload }) {
    try {
        const QUERY = `
            query getGadgetData ($type: GadgetType, $variables: String) {
                result: getGadgetData (type: $type, variables: $variables, )
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                type: 'DailyDeviceAudit',
                variables: JSON.stringify(payload)
            },
            endpoints.GRAPHQL_GENERAL,
        );
        yield put(dailyDeviceAuditResult(data?.result))

    } catch (exc) {
        yield put(dailyDeviceAuditResult(null))
        ExceptionManager(
            exc,
            "Modules/devices/.components/dailyDeviceAudit/redux/saga",
            "updateChange",
        )
    }
}

function* watchMethods() {
    yield takeEvery(DAILY_DEVICE_AUDIT_REQUEST, updateChange);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}